import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/dashboards/')({
  beforeLoad: () => {
    throw redirect({ to: '/library', search: { type: 'dashboard' }, replace: true });
  },
});
